export function validatePeriodForm (data) {
    let errors = {};    
    if (!data.title || data.title == '' || data.title == ' ')
        errors.title = 'Title is required';
    
    if (!data.authors || data.authors == '' || data.authors == ' ') 
        errors.authors = 'Authors are required';
    
    if (!data.publisher || data.publisher == '' || data.publisher == ' ')
        errors.publisher = 'Publisher is required';
    
    if (!data.year || data.year == '' || data.year == ' ')
        errors.year = 'Year is required';
    
    if (!data.pageFrom || data.pageFrom == 0 || data.pageFrom == null)
        errors.pageFrom = 'Page From is required';

    if (!data.vol || data.vol == 0 || data.vol == null)
        errors.vol = 'Volume is required';
    
    if (!data.num || data.num == 0 || data.num == null)
        errors.num = 'Number is required';
    
    if (!data.pageTo || data.pageTo == 0 || data.pageTo == null)
        errors.pageTo = 'Page To is required';
    
    if (!data.isbn || data.isbn == '' || data.isbn == ' ')
        errors.isbn = 'ISBN is required';

    if (Object.keys(errors).length > 0) {
        return errors;
    } else {
        return true;
    }
}